import NewReferralPage from './NewReferralPage';

export default NewReferralPage;
